export default {
  name: 'loginn',
  data() {
    return {
      loginn: '',
      password: '',
      info: null,
      estatoini: '',
      flgini: false
    }
  },

  beforeCreate() {
    this.$http
      .post('/SERVER/scd/sess/', {
        'a': 'isse'
      }, {
        withCredentials: true
      })
      .then(response => {
        if (response.data.status === 1) {
          if (response.data.tipo === 2) {
            window.location.href = '/#/reps/altas'
          } else if (response.data.tipo === 3) {
            window.location.href = '/#/ecash/crear'
          } else if (response.data.tipo == 9) {
            window.location.href = '/#/acciones/informevendedor'
          } else {
            window.location.href = '/#/dashboard'
          }
        }
      })
  },

  methods: {

    log: function (ev) {
      this.estatoini = 'Iniciando...'
      this.flgini = false
      this.$http
        .post('/SERVER/scd/sess/', {
          'a': 'log',
          'u': this.loginn,
          'p': this.password
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {

            if (response.data.tipo === 2) {
              window.location.href = '/#/reps/altas'
            } else if (response.data.tipo === 3) {
              window.location.href = '/#/ecash/crear'
            } else if (response.data.tipo == 6) {
              window.location.href = '/#/reps/inicio'
            } else if (response.data.tipo == 5) {
              window.location.href = '/#/reps/home'
            } else if (response.data.tipo == 9) {
              window.location.href = '/#/acciones/informevendedor'
            } else {
              window.location.href = '/#/dashboard'
            }
          } else {
            this.estatoini = 'Credenciales incorrectas'
            this.flgini = true
          }
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/loginn/loginn.js